export const OtherMenu8 = () => {
  return (
    <span>
      <svg
        className="active-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0002 22.8892C18.014 22.8892 22.8892 18.014 22.8892 12.0002C22.8892 5.98646 18.014 1.11133 12.0002 1.11133C5.98646 1.11133 1.11133 5.98646 1.11133 12.0002C1.11133 18.014 5.98646 22.8892 12.0002 22.8892ZM14.6506 5.77246C14.6506 5.22018 14.2029 4.77246 13.6506 4.77246C13.0983 4.77246 12.6506 5.22018 12.6506 5.77246V10.5613C12.6476 10.634 12.6456 10.7056 12.6444 10.7756C12.6403 11.0001 12.6435 11.2651 12.6467 11.5209C12.6487 11.6829 12.6506 11.8412 12.6506 11.9832C12.6506 12.1251 12.6487 12.2834 12.6467 12.4455V12.4455C12.6435 12.7012 12.6403 12.9663 12.6444 13.1908C12.6514 13.5774 12.679 14.0132 12.7953 14.4192C12.9171 14.8441 13.1523 15.2911 13.6063 15.6137C14.0488 15.928 14.5795 16.0386 15.1282 16.0386C17.3679 16.0386 19.1836 14.2229 19.1836 11.9832C19.1836 9.74344 17.3679 7.92778 15.1282 7.92778C14.9669 7.92778 14.8071 7.93734 14.6506 7.95882V5.77246ZM14.6459 12.5298C14.6482 12.3652 14.6506 12.1879 14.6506 11.9832V10.6086C14.6619 10.3765 14.6848 10.2139 14.7179 10.0982C14.7371 10.0314 14.7546 9.99931 14.762 9.98765C14.7637 9.98508 14.7649 9.9834 14.7657 9.9824C14.7674 9.98132 14.7713 9.97903 14.7782 9.97589C14.7881 9.97139 14.8056 9.96453 14.8331 9.95737C14.8892 9.94269 14.9829 9.92778 15.1282 9.92778C16.2634 9.92778 17.1836 10.848 17.1836 11.9832C17.1836 13.1183 16.2634 14.0386 15.1282 14.0386C14.9829 14.0386 14.8892 14.0237 14.8331 14.009C14.8056 14.0018 14.7881 13.995 14.7782 13.9905C14.775 13.989 14.7724 13.9877 14.7704 13.9867C14.7681 13.9854 14.7666 13.9845 14.7657 13.9839C14.7649 13.983 14.7637 13.9813 14.762 13.9787C14.7546 13.967 14.7371 13.935 14.7179 13.8682C14.6758 13.7212 14.6503 13.4987 14.644 13.1542C14.6402 12.9459 14.6429 12.7493 14.6459 12.5298V12.5298ZM6.81445 12.0168C6.81445 10.8816 7.73468 9.96142 8.86985 9.96142C9.0151 9.96142 9.10884 9.97633 9.165 9.99101C9.19242 9.99817 9.20992 10.005 9.21986 10.0095C9.22676 10.0127 9.23068 10.015 9.2324 10.016C9.23315 10.017 9.23437 10.0187 9.23601 10.0213C9.24345 10.033 9.26099 10.065 9.28013 10.1318C9.32224 10.2788 9.34772 10.5013 9.35402 10.8458C9.35783 11.054 9.35513 11.2507 9.35212 11.4702V11.4702C9.34986 11.6348 9.34743 11.8121 9.34743 12.0168V13.3914C9.33614 13.6235 9.31329 13.7861 9.28013 13.9018C9.26099 13.9686 9.24345 14.0007 9.23601 14.0123C9.23437 14.0149 9.23315 14.0166 9.2324 14.0176C9.23068 14.0187 9.22676 14.021 9.21986 14.0241C9.20992 14.0286 9.19242 14.0355 9.165 14.0426C9.10884 14.0573 9.0151 14.0722 8.86985 14.0722C7.73468 14.0722 6.81445 13.152 6.81445 12.0168ZM11.3537 13.2244C11.3524 13.2944 11.3505 13.366 11.3474 13.4387V18.2275C11.3474 18.7798 10.8997 19.2275 10.3474 19.2275C9.79514 19.2275 9.34743 18.7798 9.34743 18.2275V16.0412C9.19098 16.0626 9.03119 16.0722 8.86985 16.0722C6.63011 16.0722 4.81445 14.2565 4.81445 12.0168C4.81445 9.77708 6.63011 7.96142 8.86985 7.96142C9.41854 7.96142 9.94929 8.07195 10.3918 8.38632C10.8457 8.70884 11.081 9.15592 11.2027 9.58082C11.3191 9.9868 11.3466 10.4226 11.3537 10.8092C11.3578 11.0337 11.3545 11.2988 11.3514 11.5545V11.5545C11.3494 11.7166 11.3474 11.8749 11.3474 12.0168C11.3474 12.1587 11.3494 12.3171 11.3514 12.4791C11.3545 12.7349 11.3578 12.9999 11.3537 13.2244Z"
          fill="white"
        />
      </svg>

      <svg
        className="base"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_7650_34478)">
          <circle
            opacity="0.3"
            cx="12.0002"
            cy="12.0002"
            r="10.8889"
            stroke="#1A1A1A"
            strokeWidth="2"
          />
          <path
            opacity="0.3"
            d="M10.3474 12.0168C10.3474 13.7043 10.5573 15.0722 8.86985 15.0722C7.1824 15.0722 5.81445 13.7043 5.81445 12.0168C5.81445 10.3294 7.1824 8.96143 8.86985 8.96143C10.5573 8.96143 10.3474 10.3294 10.3474 12.0168ZM10.3474 12.0168V18.2275"
            stroke="#1A1A1A"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            opacity="0.3"
            d="M13.6506 11.9832C13.6506 10.2957 13.4408 8.92779 15.1282 8.92779C16.8156 8.92779 18.1836 10.2957 18.1836 11.9832C18.1836 13.6706 16.8156 15.0386 15.1282 15.0386C13.4408 15.0386 13.6506 13.6706 13.6506 11.9832ZM13.6506 11.9832V5.77247"
            stroke="#1A1A1A"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_7650_34478">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
